__turbopack_context__.v({
  "DefaultTheme": "default_theme-module__eHgn7a__DefaultTheme",
  "DesktopMenu": "default_theme-module__eHgn7a__DesktopMenu",
  "DownArrow": "default_theme-module__eHgn7a__DownArrow",
  "DownArrow2": "default_theme-module__eHgn7a__DownArrow2",
  "Footer": "default_theme-module__eHgn7a__Footer",
  "FooterItem": "default_theme-module__eHgn7a__FooterItem",
  "FooterLogo": "default_theme-module__eHgn7a__FooterLogo",
  "Logo": "default_theme-module__eHgn7a__Logo",
  "MenuItem": "default_theme-module__eHgn7a__MenuItem",
  "Menubar": "default_theme-module__eHgn7a__Menubar",
  "MiddleSectionContent": "default_theme-module__eHgn7a__MiddleSectionContent",
  "MobileMenu": "default_theme-module__eHgn7a__MobileMenu",
  "MobileRight": "default_theme-module__eHgn7a__MobileRight",
  "Search": "default_theme-module__eHgn7a__Search",
  "bg": "default_theme-module__eHgn7a__bg",
  "btn": "default_theme-module__eHgn7a__btn",
  "btn-primary": "default_theme-module__eHgn7a__btn-primary",
  "container": "default_theme-module__eHgn7a__container",
  "img": "default_theme-module__eHgn7a__img",
  "offcanvas": "default_theme-module__eHgn7a__offcanvas",
  "offcanvas-header": "default_theme-module__eHgn7a__offcanvas-header",
  "section_gaps": "default_theme-module__eHgn7a__section_gaps",
  "two": "default_theme-module__eHgn7a__two",
});
